import React, { useState } from 'react';
import { Box, Typography, TextField, Avatar, Stack, Button } from '@mui/material';
import DashboardLayoutSlots from './DashboardLayoutSlots'; // Import the layout
import heroBg from './assets/spidey.jpg'; // Default image
import LockResetIcon from '@mui/icons-material/LockReset';
import SaveIcon from '@mui/icons-material/Save';

// Profile component
function Profile() {
  const [image, setImage] = useState(heroBg); // State for profile image
  const [imageInput, setImageInput] = useState(null); // State for image input

  // Handle image change
  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      const file = URL.createObjectURL(e.target.files[0]);
      setImage(file); // Update the image to the selected file
    }
  };

  return (
    // Make sure DashboardLayoutSlots wraps the Profile page content
    <DashboardLayoutSlots>
      <Box sx={{ padding: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Profile Page
        </Typography>

        <Stack direction="column" spacing={3} sx={{ alignItems: 'center' }}>
          {/* Avatar - clickable to upload new image */}
          <label htmlFor="avatar-upload" style={{ cursor: 'pointer' }}>
            <Avatar
              alt="Profile Image"
              src={image}
              sx={{ width: 120, height: 120 }}
            />
          </label>
          <input
            id="avatar-upload"
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            style={{ display: 'none' }}
          />

          {/* Profile form */}
          <Stack direction="column" spacing={2} sx={{ width: '100%' }}>
            <TextField
              id="Name"
              label="Name"
              defaultValue="Izzat Rahman"
              fullWidth
              InputProps={{
                readOnly: true,
              }}
            />
            <TextField
              id="EmpID"
              label="Employee ID"
              defaultValue="E703X"
              fullWidth
              InputProps={{
                readOnly: true,
              }}
            />
            <TextField
              id="Email"
              label="Email"
              fullWidth
              defaultValue="izzat@evantage.com"
            />
            <TextField
              id="PhoneNumber"
              label="Phone Number"
              fullWidth
              defaultValue="0132227368"
            />

            {/* Action buttons */}
            <Stack direction="row" spacing={2} sx={{ justifyContent: 'flex-end' }}>
              <Button variant="outlined" startIcon={<LockResetIcon />} fullWidth>
                Reset Password
              </Button>
              <Button variant="contained" endIcon={<SaveIcon />} fullWidth>
                Save
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </DashboardLayoutSlots>
  );
}

export default Profile;
